import { Box, DataList, DialogBody, Flex, Image, Separator, Stack } from "@chakra-ui/react"
import { Form, UI } from "components"
import useTransactionPix from "hooks/useTransactionPix"

export default function Pix({ data, ...props }){

    const pix = useTransactionPix(data?.id)
    const account = pix.data?.account

    return(
    <UI.Dialog title="Realizar pagamento" {...props}>
        <DialogBody>
            <Stack gap={4}>

                <DataList.Root orientation="horizontal">
                    <UI.Show visible={account?.account}>
                        <DataList.Item>
                            <DataList.ItemLabel>Instituição:</DataList.ItemLabel>
                            <DataList.ItemValue>{account?.bank?.name}</DataList.ItemValue>
                        </DataList.Item>
                    </UI.Show>
                    <UI.Show visible={account?.account}>
                        <DataList.Item>
                            <DataList.ItemLabel>Agência:</DataList.ItemLabel>
                            <DataList.ItemValue>{account?.agency}</DataList.ItemValue>
                        </DataList.Item>
                        <DataList.Item>
                            <DataList.ItemLabel>Conta:</DataList.ItemLabel>
                            <DataList.ItemValue>{account?.account}</DataList.ItemValue>
                        </DataList.Item>
                    </UI.Show>
                    <DataList.Item>
                        <DataList.ItemLabel>Titular:</DataList.ItemLabel>
                        <DataList.ItemValue>{account?.name}</DataList.ItemValue>
                    </DataList.Item>
                    <UI.Show visible={account?.pix_key}>
                        <DataList.Item>
                            <DataList.ItemLabel>Tipo de chave pix:</DataList.ItemLabel>
                            <DataList.ItemValue>{account?.pix_type_label}</DataList.ItemValue>
                        </DataList.Item>
                        <DataList.Item>
                            <DataList.ItemLabel>Chave pix:</DataList.ItemLabel>
                            <DataList.ItemValue>{account?.pix_key}</DataList.ItemValue>
                        </DataList.Item>
                    </UI.Show>
                    <DataList.Item>
                        <DataList.ItemLabel>Valor:</DataList.ItemLabel>
                        <DataList.ItemValue><UI.Number.Amount value={data?.amount} /></DataList.ItemValue>
                    </DataList.Item>
                </DataList.Root>

                <Separator />

                <UI.Show visible={!!pix.data?.pix}>

                    <Flex direction="column" alignItems="center" justifyContent="center" textAlign="center">
                        <Image maxW="70%" alignSelf="center" src={pix.data?.pix?.qrcode} mb={4} />
                        <UI.Clipboard label="Pix copia e cola:" value={pix.data?.pix?.code} colorPalette="orange" />
                    </Flex>

                </UI.Show>

                <UI.Alert size="sm">Os pagamentos por pix não são processados automaticamente. Após realizar a transferência, favor anexar o comprovante de pagamento.</UI.Alert>
            </Stack>
        </DialogBody>
    </UI.Dialog>
    )
}